/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { BsGear, BsGlobe, BsShare } from 'react-icons/bs';
import { FiShield } from 'react-icons/fi';
import { HiOutlineDatabase } from 'react-icons/hi';
import { IoDocumentOutline } from 'react-icons/io5';
import { ToastContainer } from 'react-toastify';
import { Wrapper } from '../../components/Wrapper';

const PrivacyPolicyComponent: React.FC = () => {
  return (
    <div className="flex flex-col justify-center items-center gap-10 mb-10">
      {/* Header */}
      <div
        className="py-16 w-full text-white flex flex-col items-center justify-center"
        style={{ backgroundColor: '#16A34A' }}
      >
        <div
          className="rounded-full p-4 mb-4"
          style={{ backgroundColor: '#34AD61' }}
        >
          <FiShield size={44} />
        </div>
        <div className="flex flex-col items-center justify-center max-w-2xl">
          <h1 className="text-3xl font-semibold mb-4">Kebijakan Privasi</h1>
          <p className="text-lg text-center font-medium mb-6">
            Kami berkomitmen untuk melindungi privasi Anda dan memastikan
            transparansi mengenai cara kami mengumpulkan, menggunakan, dan
            melindungi informasi pribadi Anda di platform kami.
          </p>
          <p className="text-sm text-center text-gray-100">
            Last updated: 26 Januari 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="flex justify-center items-center max-w-6xl mx-auto bg-gray-100 rounded-lg border border-gray-300">
        <div className="p-10 flex flex-col gap-6">
          <div className="border-b border-gray-300 pb-8">
            <div className="flex flex-col gap-2">
              <div className="flex flex-row gap-2 items-center">
                <IoDocumentOutline size={20} style={{ color: '#16A34A' }} />
                <h2 className="text-lg font-semibold">Pendahuluan</h2>
              </div>
              <p className="text-sm font-medium">
                Aplikasi PINTAR berkomitmen untuk melindungi privasi dan data
                pribadi Pengguna sesuai dengan peraturan perundang-undangan yang
                berlaku. Kebijakan Privasi ini menjelaskan bagaimana Aplikasi
                PINTAR mengumpulkan, menggunakan, menyimpan, dan melindungi data
                Pengguna. Dengan menggunakan Aplikasi PINTAR, Pengguna dianggap
                telah menyetujui Kebijakan Privasi ini.
              </p>
            </div>
          </div>
          <div className="border-b border-gray-300 pb-8">
            <div className="flex flex-col gap-2">
              <div className="flex flex-row gap-2 items-center">
                <HiOutlineDatabase size={20} style={{ color: '#16A34A' }} />
                <h2 className="text-lg font-semibold">Pengumpulan Informasi</h2>
              </div>
              <p className="text-sm font-medium">
                Ketika Anda menggunakan PINTAR, kami dapat mengumpulkan
                informasi pribadi yang Anda berikan secara sukarela seperti :
              </p>
              <ul className="list-disc ml-4 text-sm font-medium">
                <li>Nama</li>
                <li>Alamat Email</li>
                <li>Nomor Telepon</li>
                <li>Informasi pribadi lainnya yang relevan</li>
              </ul>
              <p className="text-sm font-medium">
                Kami juga dapat mengumpulkan informasi non-pribadi seperti data
                :
              </p>
              <ul className="list-disc ml-4 text-sm font-medium">
                <li>Penggunaan aplikasi</li>
                <li>Statistik</li>
                <li>
                  Informasi teknis lainnya yang terkait dengan penggunaan Anda
                </li>
              </ul>
            </div>
          </div>
          <div className="border-b border-gray-300 pb-8">
            <div className="flex flex-col gap-2">
              <div className="flex flex-row gap-2 items-center">
                <BsGear size={20} style={{ color: '#16A34A' }} />
                <h2 className="text-lg font-semibold">Izin Aplikasi</h2>
              </div>
              <p className="text-sm font-medium">
                Untuk menjalankan fungsinya, Aplikasi PINTAR memerlukan izin
                berikut :
              </p>
              <ul className="list-disc ml-4 text-sm font-medium">
                <li>
                  Kamera dan Media : Digunakan untuk unggah dokumen, foto, atau
                  kebutuhan administrasi lainnya.
                </li>
                <li>
                  Penyimpanan Perangkat : Digunakan untuk menyimpan atau
                  mengunduh dokumen seperti sertifikat digital.
                </li>
                <li>
                  Internet : Digunakan untuk mengakses layanan aplikasi dan
                  sinkronisasi data.
                </li>
              </ul>
            </div>
          </div>
          <div className="border-b border-gray-300 pb-8">
            <div className="flex flex-col gap-2">
              <div className="flex flex-row gap-2 items-center">
                <BsGlobe size={20} style={{ color: '#16A34A' }} />
                <h2 className="text-lg font-semibold">Penggunaan Data</h2>
              </div>
              <p className="text-sm font-medium">
                Data yang dikumpulkan digunakan untuk :
              </p>
              <ul className="list-disc ml-4 text-sm font-medium">
                <li>Menyediakan dan mengelola layanan Aplikasi PINTAR.</li>
                <li>
                  Mendukung proses pelatihan, berbagi pengetahuan, dan
                  sertifikasi digital.
                </li>
                <li>Menjaga keamanan dan stabilitas sistem.</li>
                <li>Meningkatkan kualitas layanan dan pengalaman pengguna.</li>
              </ul>
            </div>
          </div>
          <div className="border-b border-gray-300 pb-8">
            <div className="flex flex-col gap-2">
              <div className="flex flex-row gap-2 items-center">
                <BsShare size={20} style={{ color: '#16A34A' }} />
                <h2 className="text-lg font-semibold">Pembagian Data</h2>
              </div>
              <p className="text-sm font-medium">
                Aplikasi PINTAR tidak membagikan data pribadi Pengguna kepada
                pihak ketiga, kecuali:
              </p>
              <ul className="list-disc ml-4 text-sm font-medium">
                <li>
                  Diwajibkan oleh ketentuan hukum dan peraturan yang berlaku.
                </li>
                <li>
                  Diperlukan untuk kepentingan keamanan sistem dan layanan
                  aplikasi.
                </li>
              </ul>
            </div>
          </div>
          <div className="pb-8">
            <div className="flex flex-col gap-2">
              <div className="flex flex-row gap-2 items-center">
                <FiShield size={20} style={{ color: '#16A34A' }} />
                <h2 className="text-lg font-semibold">Keamanan Data</h2>
              </div>
              <p className="text-sm font-medium">
                Aplikasi PINTAR menerapkan langkah-langkah pengamanan teknis dan
                organisasi yang wajar untuk melindungi data pribadi dari akses,
                penggunaan, atau pengungkapan yang tidak sah
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const WrapperMain: React.FC = () => {
  return (
    <Wrapper>
      {/* Content */}
      <PrivacyPolicyComponent />
    </Wrapper>
  );
};

const PrivacyPolicyPage: React.FC = () => {
  return (
    <>
      <ToastContainer
        position="top-center"
        style={{ width: '60%', marginTop: '5%' }}
      />
      <WrapperMain />
    </>
  );
};

export default PrivacyPolicyPage;
